<template>
  <div class="home_desc">
    <LayoutTopComponent></LayoutTopComponent>

    <div class="desc_top" ref="pagesRef">
      <el-carousel :height="pagesHeight + 'px'" :autoplay="true" :interval="5000">
        <el-carousel-item v-for="(item,index) in descImgList" :key="index">
          <img @click="itemClick(item,index)" class="imgCls" :src="item.url">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="desc_center">
      <div class="desc_center_body">
        <div class="desc_center_body_item" @click="toEducation">
          <div class="desc_center_body_item_img">
            <img src="../assets/images/desc_center_001.png">
          </div>
          <div class="desc_center_body_item_text">教育产品</div>
        </div>
        <div class="desc_center_body_item" @click="toEnvironmental">
          <div class="desc_center_body_item_img">
            <img src="../assets/images/desc_center_002.png">
          </div>
          <div class="desc_center_body_item_text">环保产品</div>
        </div>
        <div class="desc_center_body_item">
          <div class="desc_center_body_item_img">
            <img src="../assets/images/desc_center_003.png">
          </div>
          <div class="desc_center_body_item_text">软件产品</div>
        </div>
        <div class="desc_center_body_item">
          <div class="desc_center_body_item_img">
            <img src="../assets/images/desc_center_004.png">
          </div>
          <div class="desc_center_body_item_text">其他配件</div>
        </div>
      </div>

    </div>

    <div class="desc_bottom" ref="descBottomRes">
      <div class="desc_bottom_decorate">
        <div class="desc_bottom_title">环保产品 ></div>
        <div class="desc_bottom_body">
          <div v-for="(item,index) in descBottomImgList" :key="index" class="desc_bottom_body_item">
            <div class="body_item_img">
              <img :src="item.url">
            </div>
            <div class="body_item_bottom">
              <div class="body_item_bottom_title">{{ item.title }}</div>
              <img @click="itemClick(item,index)"
                   src="../assets/images/desc_bottom_arrow.png">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="desc_bottom" style="margin-top: 72px" ref="descBottomRes2">
      <div class="desc_bottom_decorate">
        <div class="desc_bottom_title">教育产品 ></div>
        <div class="desc_bottom_body">
          <div v-for="(item,index) in descCopyImgList" :key="index" class="desc_bottom_body_item">
            <div class="body_item_img">
              <img :src="item.url">
            </div>
            <div class="body_item_bottom">
              <div class="body_item_bottom_title">{{ item.title }}</div>
              <img @click="itemClick(item,index)" src="../assets/images/desc_bottom_arrow.png">
            </div>
          </div>
        </div>
      </div>
    </div>

    <LayoutBottomComponent></LayoutBottomComponent>

  </div>
</template>

<script>

import LayoutTopComponent from "../components/LayoutTopComponent";
import LayoutBottomComponent from "../components/LayoutBottomComponent";

export default {

  data() {
    return {
      pagesHeight: '',
      descImgList: [
        {
          url: require("../assets/images/desc_top_001.png"),
          type: "BLZNC03"
        }
      ],
      descBottomImgList: [
        {
          url: require("../assets/images/desc_bottom_hc3620.png"),
          type: "HC3620",
          title: "智能回收秤"
        },
        {
          url: require("../assets/images/desc_bottom_cc3623.png"),
          type: "CC3623",
          title: "智能厨房秤"
        },
        {
          url: require("../assets/images/desc_bottom_blhsg03.png"),
          type: "BLHSG03",
          title: "智能回收柜"
        },
        {
          url: require("../assets/images/desc_bottom_tf3661.png"),
          type: "TF3661",
          title: "智能投放门"
        },
        {
          url: require("../assets/images/desc_bottom_blznc03.png"),
          type: "BLZNC03",
          title: "智能收集秤"
        },
        {
          url: require("../assets/images/desc_bottom_bl3fl02.png"),
          type: "BL3FL02",
          title: "智能三分类垃圾箱"
        },
        {
          url: require("../assets/images/desc_bottom_blpjs01.png"),
          type: "BLPJS01",
          title: "智能分类评价设备"
        },
        {
          url: require("../assets/images/desc_bottom_bl2fl01.png"),
          type: "BL2FL01",
          title: "智能两分类垃圾箱"
        },
        {
          url: require("../assets/images/desc_bottom_blshj02.png"),
          type: "BLSHJ02",
          title: "智能积分售货机"
        },
        {
          url: require("../assets/images/desc_bottom_blfgc01.png"),
          type: "BLFGC01",
          title: "废品管家"
        },
        {
          url: require("../assets/images/desc_bottom_tz3620.png"),
          type: "TZ3670",
          title: "智能投放站"
        }
      ],
      descCopyImgList: [
        {
          url: require("../assets/images/desc_bottom_fk4151.png"),
          type: "FK4151",
          title: "智能访客机"
        },
        {
          url: require("../assets/images/desc_bottom_vtcwm101.png"),
          type: "VTCWM101",
          title: "环卫车辆专用智能运行监管仪"
        },
        {
          url: require("../assets/images/desc_bottom_vtyhv1.png"),
          type: "VTYHV1",
          title: "油耗检测设备"
        },
        {
          url: require("../assets/images/desc_bottom_cj9100.png"),
          type: "CJ9100",
          title: "晨检机"
        },
        {
          url: require("../assets/images/desc_bottom_kg4002.png"),
          type: "KG4002",
          title: "刷卡机"
        },
        {
          url: require("../assets/images/desc_bottom_bp4202.png"),
          type: "BP4202",
          title: "电子班牌"
        },
        {
          url: require("../assets/images/desc_bottom_zj4362.png"),
          type: "ZJ4362",
          title: "闸机(ZJ4362)"
        },
        {
          url: require("../assets/images/desc_bottom_zj4361.png"),
          type: "ZJ4361",
          title: "闸机(ZJ4361)"
        }
      ],
    }
  },
  mounted() {
    this.pagesHeight = this.$refs.pagesRef.clientHeight;
  },
  components: {
    LayoutTopComponent,
    LayoutBottomComponent
  },
  methods: {
    itemClick: function (res, index) {
      if (res.type) {
        this.$router.push("/Detail?&type=" + res.type)
      }
    },
    toEducation: function () {
      let element = this.$refs.descBottomRes2;
      element.scrollIntoView();
    },
    toEnvironmental: function () {
      let element = this.$refs.descBottomRes;
      element.scrollIntoView();
    }
  }

}
</script>

<style lang="less" scoped>

@import "../assets/css/common";

@media screen and (max-width: 1280px) {

  .home_desc {
    width: @screenWidth1280;
    margin-top: @layoutTopHight1280;

    .desc_top {
      height: @viewPager1280;

      .imgCls {
        width: 100%;
        height: @viewPager1280;
      }
    }

    .desc_center_body {
      margin-top: -90px;
    }

    .desc_bottom {
      padding: 24px 22px;
    }

  }

}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .home_desc {
    width: @screenWidth1440;
    margin-top: @layoutTopHight1440;

    .desc_top {
      height: @viewPager1440;

      .imgCls {
        width: 100%;
        height: @viewPager1440;
      }
    }

    .desc_center_body {
      margin-top: -90px;
    }

    .desc_bottom {
      padding: 30px 66px;
    }

  }

}

@media screen and (min-width: 1441px) and (max-width: 1920px) {

  .home_desc {
    width: @screenWidth1920;
    margin-top: @layoutTopHight1920;

    .desc_top {
      height: @viewPager1920;

      .imgCls {
        width: 100%;
        height: @viewPager1920;
      }
    }

    .desc_center_body {
      margin-top: -144px;
    }

    .desc_bottom {
      padding: 36px 300px;
    }

  }
}


.home_desc {
  display: flex;
  flex-direction: column;

  .desc_top {
  }

  .desc_center {
    display: flex;
    justify-content: center;
    height: 120px;
    background: #ffffff;
    z-index: 999;

    .desc_center_body {
      display: flex;
      justify-content: space-between;

      .desc_center_body_item {
        margin: 0 12px;
        display: flex;
        flex-direction: column;
        width: 280px;
        height: 186px;
        background: url("../assets/images/desc_center_item_bg.png");
        cursor: pointer;

        .desc_center_body_item_img {
          margin-top: 49px;
        }

        .desc_center_body_item_text {
          margin-top: 10px;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 48px;
        }

      }
    }
  }

  .desc_bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #F6F6F6;

    .desc_bottom_decorate {
      display: flex;
      flex-direction: column;

      .desc_bottom_title{
        padding-top: 60px;
        text-align: left;
        margin-left: 10px;
        font-size: 30px;
        color: #2A57EA;
      }

      .desc_bottom_body {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .desc_bottom_body_item {
          margin: 15px;
          display: flex;
          flex-direction: column;
          align-items: center;
          border: 1px dashed #333333;

          .body_item_img {
            background: #F6F6F6;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 380px;
            height: 300px;
          }

          .body_item_bottom {
            display: flex;
            width: 100%;
            justify-content: space-around;
            align-items: center;
            background: #ffffff;

            .body_item_bottom_title {
              font-size: 20px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #2A57EA;
              line-height: 60px;
            }

            img:hover {
              cursor: pointer;
            }

          }
        }
      }
    }


  }

}

</style>

